<template>
  <EditCom
    :title="title"
    :target="target"
    :buttonList="buttonList"
    :inputList="inputList"
    :rules="rules"
    @closeFun="close"
  ></EditCom>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';

import EditCom from '@/components/EditCom';

import {
  loadUserWorkspaceData,
} from '@/api/UserWorkspaceApi';

import {
  queryAirTypeList,
} from '@/api/DictApi';

// props
const props = defineProps({
  title: { type: String, },
  target: { type: Object, },
});
// emit
const emit = defineEmits([
  'close', 'submitCallback',
]);

const close = ()=>{
  emit('close');
}

const dataTypeList = [
  { id: 1, label: '全球曝光', },
  // { id: 2, label: '轨迹数据', },
  { id: 6, label: '轨迹数据', },
  { id: 3, label: 'NOTAM', },
  { id: 4, label: 'NTM', },
  { id: 5, label: 'TFR', },
];
const target = reactive({
  ...props.target,
  dataTypeList: dataTypeList,
});

const submitFn = (item, button, loadFn, fn)=>{
  // console.log(item);
  emit('submitCallback', {
    startTime: dayjs(item['startTime']).format('YYYY-MM-DD'),
    endTime: dayjs(item['endTime']).format('YYYY-MM-DD'),
  })
}
const submit = (form, item, button, loadFn, fn)=>{
  // console.log(form, item, button, loadFn, fn);
  form.value.validate((valid)=>{
    // console.log(valid);
    if(valid){
      submitFn(item, button, loadFn, fn);
    }else{
      loadFn && loadFn();
    }
  });
};
const inputListInitial = [
  { name: '开始时间', prop: 'startTime', type: 'date', date: {}, },
  { name: '结束时间', prop: 'endTime', type: 'date', date: {}, },
]


const buttonList = ref([
  { name: '取消', fun: close, type: 'danger', },
  { name: '确定', fun: submit, type: 'primary', },
]);
const inputList = ref(inputListInitial);
const rules = reactive({
  startTime: [
    { required: true, message: '请选择开始时间', trigger: 'blur' },
  ],
  endTime: [
    { required: true, message: '请选择结束时间', trigger: 'blur' },
  ],
});

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(async ()=>{
  
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>